import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { isValidLanguage } from "@/lib/i18n";

export const Route = createFileRoute("/$lang")({
  beforeLoad: ({ params }) => {
    // Validate that the language parameter is a supported language code (not "en")
    if (!isValidLanguage(params.lang) || params.lang === "en") {
      throw redirect({ to: "/" });
    }
  },
  component: LangLayout,
});

function LangLayout() {
  return <Outlet />;
}
